import { h } from 'hyperapp'
import s from './Title.module.css'

const Title = () => (
  <div class={s.wrap}>
    <svg
      class={s.svg}
      viewBox="0 0 560 52"
      role="img"
      aria-label="TrumpSweeper.com"
    >
      <g
        class={s.letters}
        font-family="Impact, Haettenschweiler, 'Arial Narrow Bold', Arial Black, sans-serif"
        font-size="36"
        font-weight="700"
        letter-spacing="0.05em"
      >
        <text
          x="0"
          y="40"
          text-anchor="start"
          fill="none"
          stroke="#0b1220"
          stroke-width="7"
          stroke-linejoin="round"
          stroke-linecap="round"
        >
          TrumpSweeper.com
        </text>
        <text
          x="0"
          y="40"
          text-anchor="start"
          fill="none"
          stroke="#fff"
          stroke-width="4.5"
          stroke-linejoin="round"
          stroke-linecap="round"
        >
          TrumpSweeper.com
        </text>
        <text x="0" y="40" text-anchor="start" fill="#e0302d">
          TrumpSweeper.com
        </text>
      </g>
    </svg>
  </div>
)

export default Title
